<section id="main" role="main">
  <div class="wk-row margin-0">
    <div class="wk-col-xs-12 wk-col-md-12 wk-col-lg-12 padding-0">
      <section class="box-container">
        <div class="main" id="dynamic-content">
          <router-outlet></router-outlet>
        </div>
      </section>
    </div>
  </div>
</section>
